import {ProductReview} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_reviews.types';
import {HorizontalSlider} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {UserReviewCard} from './UserReviewCard';

export const ReviewsUserReview: FC<{
  showcaseReviews: ProductReview[];
  showSlider: boolean;
}> = ({showcaseReviews, showSlider}) => {
  const UsersReviewsComponent =
    showcaseReviews.length > 1 && showSlider
      ? HorizontalSlider
      : UsersReviewsContainer;

  let reviews = showcaseReviews.slice();
  if (!showSlider && reviews.length > 1) {
    reviews = reviews.slice(0, 1);
  }

  const isSliderShown = showcaseReviews.length > 1 && showSlider;

  const usersReviewsProps =
    reviews.length > 1
      ? {
          slideCount: 1,
          disableHeaderControl: true,
          hideSideButtons: true,
          dataTestId: 'userReviewsSlider',
        }
      : {
          'data-testid': 'userReviewsStatic',
        };

  return (
    <UsersReviewsComponent {...usersReviewsProps}>
      {reviews.map((showcaseReview, index) => (
        <UserReviewCard
          showcaseReview={showcaseReview}
          key={`userReviewCard-tile-${index}`}
          reducePadding={true}
          maxReviewTextCharacters={55}
          reducedWith={isSliderShown}
          reduceMargin={isSliderShown}
        />
      ))}
    </UsersReviewsComponent>
  );
};

const UsersReviewsContainer = styled.div``;
